import { t } from 'i18next'
import { Item } from '../../../../../store/types'
import i18n from '../../../../../config/i18n'
import Carousel from '../../schedule/carousel/CustomCarousel'
import { environment } from '../../../../../enviroments/enviroment'


const translationBase = 'components.infoSidebar.worklog.carousel.cost'
const urlBase = `${environment.publicUrl}/assets/image/carousel/info/cost`

const LIGHT_PL_1 = `${urlBase}/cost-light-PL-1.png`
const LIGHT_PL_2 = `${urlBase}/cost-light-PL-2.png`
const LIGHT_PL_3 = `${urlBase}/cost-light-PL-3.png`

const DARK_PL_1 = `${urlBase}/cost-dark-PL-1.png`
const DARK_PL_2 = `${urlBase}/cost-dark-PL-2.png`
const DARK_PL_3 = `${urlBase}/cost-dark-PL-3.png`

const LIGHT_EN_1 = `${urlBase}/cost-light-EN-1.png`
const LIGHT_EN_2 = `${urlBase}/cost-light-EN-2.png`
const LIGHT_EN_3 = `${urlBase}/cost-light-EN-3.png`

const DARK_EN_1 = `${urlBase}/cost-dark-EN-1.png`
const DARK_EN_2 = `${urlBase}/cost-dark-EN-2.png`
const DARK_EN_3 = `${urlBase}/cost-dark-EN-3.png`

const CostCarousel = () => {
  const isPolish = i18n.language === 'pl'
  const items: Item[] = [
    {
      subtitle: t(`${translationBase}.button.subtitle`),
      description: t(`${translationBase}.button.description`),
      imageLight: isPolish ? LIGHT_PL_1 : LIGHT_EN_1,
      imageDark: isPolish ? DARK_PL_1 : DARK_EN_1,
      key: 'carousel-worklog-info-cost-1',
    },
    {
      subtitle: t(`${translationBase}.view.subtitle`),
      description: t(`${translationBase}.view.description`),
      imageLight: isPolish ? LIGHT_PL_2 : LIGHT_EN_2,
      imageDark: isPolish ? DARK_PL_2 : DARK_EN_2,
      key: 'carousel-worklog-info-cost-2',
    },
    {
      subtitle: t(`${translationBase}.inserting.subtitle`),
      description: t(`${translationBase}.inserting.description`),
      imageLight: isPolish ? LIGHT_PL_3 : LIGHT_EN_3,
      imageDark: isPolish ? DARK_PL_3 : DARK_EN_3,
      key: 'carousel-worklog-info-cost-3',
    },
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={items} />
}

export default CostCarousel
